<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/mixins";

  .character-counter {
    @include mixins.overline();
    @include colors.color(textGrey);

    &.over {
      @include colors.color(systemWarning_100);
    }

    &.disabled {
      @include colors.color(textDisabledGrey);
    }
  }
</style>

<script>
  export let text = "";
  export let characterLimit = false; // Integer or false, state to warning if exceeded
  export let over = false;
  export let disabled = false;

  $: characterCount = text?.length || 0;
  $: over = characterLimit && characterCount > characterLimit;
</script>

<div class="character-counter" class:over class:disabled>
  {characterCount}{characterLimit ? `/${characterLimit}` : ""} CHARACTERS
</div>
